import { Modifier, type DragOperation } from "@dnd-kit/abstract";
import type { Coordinates } from "@dnd-kit/geometry";

interface ScaleTransformOptions {
  scale: number;
}

/**
 * Modifier that compensates for a CSS-scaled container (e.g. zoom).
 * Divides the drag transform by the given scale factor so the element
 * tracks the pointer correctly inside a `transform: scale(...)` parent.
 */
export class ScaleTransform extends Modifier<any, ScaleTransformOptions> {
  apply({ transform }: DragOperation): Coordinates {
    if (this.disabled) return transform;

    const scale = this.options?.scale ?? 1;

    return {
      x: transform.x / scale,
      y: transform.y / scale,
    };
  }
}
